export default class StudentStopRequest {
  emailAddressList = [];
  constructor(datas) {
    for (var i = 0; i < datas.length; i++) {
      this.emailAddressList.push(datas[i].email);
    }
  }
}
